var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.scopes, function(scope, key) {
        return [
          typeof scope === "object" || Array.isArray(scope)
            ? [
                _c(
                  "div",
                  {
                    key: key,
                    staticClass: "form-group",
                    class: {
                      "wp-5": _vm.parent === "all",
                      "pl-4": key !== "all"
                    },
                    attrs: { id: "id-form-opt-" + key }
                  },
                  [
                    _c("label", { staticClass: "form-label label-auto bold" }, [
                      _c("input", {
                        attrs: {
                          type: "checkbox",
                          name: "options[]",
                          id: "opt-" + key
                        },
                        domProps: {
                          value: "" + key,
                          checked: _vm.isChecked(key)
                        },
                        on: {
                          change: function($event) {
                            return _vm.handleChecked(
                              key,
                              scope,
                              $event.target.checked,
                              true
                            )
                          }
                        }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(key === "all" ? _vm.$l10n.__("Tous") : key) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("scopes-input", {
                      class: { "scope-group": !_vm.parent },
                      attrs: {
                        scopes: scope ? scope : [],
                        value: _vm.value,
                        parent: key,
                        handleChecked: _vm.handleChecked
                      }
                    })
                  ],
                  1
                )
              ]
            : [
                _c("div", { key: key, staticClass: "form-group ml-4" }, [
                  _c("label", { staticClass: "form-label label-auto" }, [
                    _c("input", {
                      attrs: {
                        type: "checkbox",
                        name: "options[]",
                        id: "opt-" + scope
                      },
                      domProps: {
                        value: "" + scope,
                        checked: _vm.isChecked(scope)
                      },
                      on: {
                        change: function($event) {
                          return _vm.handleChecked(
                            key,
                            scope,
                            $event.target.checked,
                            true
                          )
                        }
                      }
                    }),
                    _vm._v(
                      "\n                " + _vm._s(scope) + "\n            "
                    )
                  ])
                ])
              ]
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }